export { az } from '@payloadcms/translations/languages/az'
